// extracted by mini-css-extract-plugin
export var card = "Card-module--card--XjJUX";
export var wrapper = "Card-module--wrapper--169Ts";
export var content = "Card-module--content--1MQ6B";
export var fixedWidth = "Card-module--fixedWidth--l_SwA";
export var closeButton = "Card-module--closeButton--5x9mD";
export var text = "Card-module--text--3C6O2";
export var extra = "Card-module--extra--nAKCV";
export var more = "Card-module--more--1uaqK";
export var ending = "Card-module--ending--5l099";
export var actions = "Card-module--actions--3B3ya";